export enum ObjectType {
    INSPECTIONS = 'inspections',
    ANOMALIES = 'anomalies',
    POINTS_AUDIT = 'pointsAudit'
}
